<template>
  <pluggable-as-dialog max-width="800" @click:outside="$emit('on:disagree')">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"> </slot>
    </template>

    <template v-slot:content>
      <skeletal-loader type="article">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> Telefon Sayısı </v-list-item-title>
              <v-list-item-subtitle>
                {{ context.count }} adet
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> SMS Başlığı </v-list-item-title>
              <v-list-item-subtitle>
                {{ context.sender }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="context.amount_of_message !== null">
            <v-list-item-content>
              <v-list-item-title> SMS Tutarı </v-list-item-title>
              <v-list-item-subtitle>
                {{ context.amount_of_message }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> Gönderim Zamanı </v-list-item-title>
              <v-list-item-subtitle>
                {{ context.time }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </skeletal-loader>
      <v-divider> </v-divider>
      <v-subheader :class="{ 'pt-3': $vuetify.breakpoint.xs }">
        Gönderilecek mesajların bir kısmı örnek olarak aşağıda listelenmektedir.
      </v-subheader>
      <v-data-table
        :headers="headers"
        :items="context.examples"
        hide-default-footer
      >
      </v-data-table>
      <v-card-actions class="align-center justify-center">
        <v-btn
          color="red darken-1"
          depressed
          dark
          @click="$emit('on:disagree')"
        >
          İptal
          <v-icon right dark> mdi-close </v-icon>
        </v-btn>
        <v-btn
          color="green darken-1"
          depressed
          dark
          @click="
            () => {
              $emit('on:agree');
              $emit('on:disagree');
            }
          "
        >
          Gönder
          <v-icon right dark> mdi-check </v-icon>
        </v-btn>
      </v-card-actions>
    </template>
  </pluggable-as-dialog>
</template>

<script>
import PluggableAsDialog from './Pluggable/PluggableAsDialog.vue';
import SkeletalLoader from './SkeletalLoader.vue';

export default {
  name: 'SmsConfirmation',
  components: { SkeletalLoader, PluggableAsDialog },
  props: ['context', 'valid'],
  data: () => ({
    headers: [
      { text: 'Cep Telefonu', value: 'number' },
      { text: 'Alıcı Adı', value: 'name' },
      { text: 'Mesaj', value: 'message' },
      { text: 'Karakter/Boy', value: 'length' },
    ],
  }),
  watch: {
    valid(nv) {
      if (nv) {
        this.$trigger('setPluginDialog');
      }
    },
  },
};
</script>
